import {AssetStatus, type IAsset} from '../schema';

/**
 * This test is cribbed from Flex: it checks the asset.status value to make sure the asset file is actually available on the DAM.
 * @returns Asset is present
 */
export const assetIsPresent = (asset?: IAsset): asset is IAsset =>
	!!asset &&
	[AssetStatus.ONLINE, AssetStatus.TEMP, AssetStatus.NEARLINE].includes(
		asset.status,
	);
